// src/components/games/pipsCreatureKeeper/CaptureSuccess.tsx

import React, { useEffect } from 'react';
import { soundService } from '../../../services/soundService';
import './CaptureSuccess.css';

interface CaptureSuccessProps {
  creatureName: string;
  compatibility: number;
  onComplete: () => void;
}

const CaptureSuccess: React.FC<CaptureSuccessProps> = ({
  creatureName,
  compatibility,
  onComplete
}) => {
  useEffect(() => {
    // Play capture success sound
    soundService.play('creature-catch', { volume: 0.7, haptic: 'success' });

    // Create sparkles
    const sparkleCount = 30;
    const container = document.querySelector('.capture-success-content');

    if (container) {
      for (let i = 0; i < sparkleCount; i++) {
        setTimeout(() => {
          const sparkle = document.createElement('div');
          sparkle.className = 'sparkle';
          sparkle.style.left = `${Math.random() * 100}%`;
          sparkle.style.top = `${Math.random() * 100}%`;
          sparkle.style.animationDelay = `${Math.random() * 0.5}s`;
          container.appendChild(sparkle);

          setTimeout(() => sparkle.remove(), 2000);
        }, i * 50);
      }
    }

    // Create confetti
    const confettiCount = 50;
    const overlay = document.querySelector('.capture-success-overlay');
    const colors = ['#FFD700', '#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', '#98D8C8', '#F7DC6F', '#BB8FCE'];

    if (overlay) {
      for (let i = 0; i < confettiCount; i++) {
        setTimeout(() => {
          const confetti = document.createElement('div');
          confetti.className = 'confetti';
          confetti.style.left = `${Math.random() * 100}%`;
          confetti.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
          confetti.style.animationDelay = `${Math.random() * 0.3}s`;
          confetti.style.animationDuration = `${2 + Math.random() * 2}s`;
          overlay.appendChild(confetti);

          setTimeout(() => confetti.remove(), 5000);
        }, i * 20);
      }
    }

    // Create star burst
    const starBurstCount = 16;
    if (container) {
      for (let i = 0; i < starBurstCount; i++) {
        const angle = (i / starBurstCount) * Math.PI * 2;
        const distance = 300;
        const x = Math.cos(angle) * distance;
        const y = Math.sin(angle) * distance;

        const star = document.createElement('div');
        star.className = 'star-burst';
        star.style.setProperty('--x', `${x}px`);
        star.style.setProperty('--y', `${y}px`);
        star.style.animationDelay = `${i * 0.05}s`;
        container.appendChild(star);

        setTimeout(() => star.remove(), 1000);
      }
    }

    // Auto-complete after 4 seconds
    const timer = setTimeout(onComplete, 4000);

    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div className="capture-success-overlay">
      <div className="capture-success-content">
        <div className="glow-pulse"></div>

        <span className="capture-success-emoji">✨🎉✨</span>

        <h2 className="capture-success-title">Capture Successful!</h2>

        <p className="capture-success-creature">{creatureName}</p>

        <p className="capture-success-stats">
          Compatibility: {compatibility}%
        </p>

        <p className="capture-success-message">
          Returning to habitats in a moment...
        </p>
      </div>
    </div>
  );
};

export default CaptureSuccess;